import * as R from 'ramda';
import { Message } from '../../../contexts/chatSocket/reducer/chatSocketReducer.types';

// TODO: REFATORAR ESSA CLASSE, TA MUITO CONFUSO
class MessageIncrementer {
  static getNewMessages(message: Message, currentMessages: Message[]): Message[] {
    const withTempId = !R.isNil(message.tempId);
    const withId = !R.isNil(message.id);

    if ((withTempId && withId) || message.error) {
      return this.replaceConfirmedMessage(message, currentMessages);
    }

    if (!withTempId && !withId) {
      return currentMessages;
    }

    const alreadyHasThisMessage = currentMessages.some(({ tempId }) => tempId === message.tempId);
    if (withTempId && alreadyHasThisMessage) {
      return currentMessages;
    }

    return this.sortMessages([...currentMessages, message]);
  }

  private static replaceConfirmedMessage(message: Message, currentMessages: Message[]): Message[] {
    const temporaryMessageIndex = currentMessages.findIndex(
      ({ tempId }) => tempId === message.tempId,
    );
    if (temporaryMessageIndex === -1) {
      return this.sortMessages([...currentMessages, message]);
    }

    const newMessages = [...currentMessages];
    newMessages.splice(temporaryMessageIndex, 1, message);

    return this.sortMessages(newMessages);
  }

  private static sortMessages(messages: Message[]): Message[] {
    return R.sortWith(
      [R.ascend((message) => (message.error ? 1 : 0)), R.ascend(R.prop('createdAt'))],
      messages,
    );
  }
}

export default MessageIncrementer;
